import { post, get } from '@/util/request'
const getCaptcha = () => post('/public/login/captcha')
const login = (params) => post('/public/login/do', params)
const setupPassword = (params) => post('/public/login/passwd', params)
const loginVerify = (params) => post('/public/login/verify', params)
export { getCaptcha, login, setupPassword, loginVerify, }
